export class CustomFieldAssignmentDto<TValue> {
    fieldId: number;
    fieldValue: TValue;

    constructor(fieldId: number, fieldValue: TValue) {
      this.fieldId = fieldId;
      this.fieldValue = fieldValue
    }
}
